module.exports = __webpack_public_path__ + "img/banner-public-bank.ce415bd0.png";